<template>
  <div class=" bg-white">
    <nav-bar />

    <hero />

    <tutors />

    <page-footer />
  </div>
</template>

<script>
import navBar from './components/navBar.vue'
import hero from './components/hero.vue'
import tutors from './tutors/tutorsList.vue'
import pageFooter from './components/pageFooter.vue'

export default {
  components: {
    navBar,
    hero,
    tutors,
    pageFooter,
  },
}
</script>

<style scoped>
/*--------------------------------------------------------------
# General
--------------------------------------------------------------*/
body {
  font-family: "Open Sans", sans-serif;
  color: #444444;
}

a {
  color: #3498db;
  text-decoration: none;
}

a:hover {
  color: #5faee3;
  text-decoration: none;
}

/*--------------------------------------------------------------
# Back to top button
--------------------------------------------------------------*/
.back-to-top {
  position: fixed;
  visibility: hidden;
  opacity: 0;
  right: 15px;
  bottom: 15px;
  z-index: 996;
  background: #3498db;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  transition: all 0.4s;
}

.back-to-top i {
  font-size: 28px;
  color: #fff;
  line-height: 0;
}

.back-to-top:hover {
  background: #57aae1;
  color: #fff;
}

.back-to-top.active {
  visibility: visible;
  opacity: 1;
}

</style>
